/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON, FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON, } from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';
/**
 * Check if a given object implements the FxGamesLibWebRpcContractsResponse interface.
 */
export function instanceOfFxGamesLibWebRpcContractsResponse(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    return true;
}
export function FxGamesLibWebRpcContractsResponseFromJSON(json) {
    return FxGamesLibWebRpcContractsResponseFromJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
        'ResponseError': json['ResponseError'] == null ? undefined : FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json['ResponseError']),
    };
}
export function FxGamesLibWebRpcContractsResponseToJSON(json) {
    return FxGamesLibWebRpcContractsResponseToJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
        'ResponseError': FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(value['ResponseError']),
    };
}
//# sourceMappingURL=FxGamesLibWebRpcContractsResponse.js.map